<template>
  <Dialog
    custom-class="pg-dialog-scan-epc pg-dialog"
    :title="title"
    :visible="showDrawer"
    :modal="modal"
    :before-close="onCancel"
    :append-to-body="appendToBody"
    :width="width"
    :top="top"
    @close="close"
    @closed="closed"
  >
    <!-- content: scan-epc -->
    <PgInputScan :placeholder="placeholder" @on-scan="onScan"></PgInputScan>
  </Dialog>
</template>

<script setup>
import { toRefs } from 'vue'
import { Dialog } from 'element-ui'
import { PgInputScan } from '../../input-scan/index'
import { useDrawerPack } from '../../../hooks/index'
import { useDialogScanEpc } from '../hook/index'
import { useBeforValueOldActions } from '../../../hooks/index'

const emit = defineEmits(['update:visible', 'close', 'closed', 'on-cancel', 'on-ok', 'input'])

const props = defineProps({
  store: { type: Object },
  appendToBody: {
    type: Boolean,
    default: true,
  },
  visible: {
    type: Boolean,
    default: true,
  },
  modal: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '自定义序列号扫码',
  },
  width: {
    type: String,
    default: '640px',
  },
  top: {
    type: String,
    default: '-30vh',
  },
  placeholder: {
    type: String,
  },
  beforValueAction: {
    type: Object,
  },
  noRequest: {
    type: Boolean,
    default: false,
  },
  // 扫码识别条码后触发的接口
  url: String,
  urlMethod: {
    type: String,
    default: 'get',
  },
  urlParamter: Object,
})
const { visible } = toRefs(props)

// 优先兼容 #7549 需求涉及到的页面。适配新组件库 pangu-component-plus 的后续引入 useBeforValueActions
const { beforeEmit } = useBeforValueOldActions({
  store: props.store,
  beforValueAction: props.beforValueAction,
  emit,
})
const { showDrawer, close, closed, onCancel } = useDrawerPack(visible, emit)
const { onScan } = useDialogScanEpc({ props, beforeEmit })
</script>

<style lang="scss"></style>
